import { selectCurrentHotelName } from 'accessors'
import EditContentButtonIcon from 'features/EmailEditor/EditContentButton'
import { useEmailEditor } from 'features/EmailEditor/EmailEditorContext'
import moment from 'moment'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import styles from './EmailEditor.module.scss'

export const EmailInboxPreview = () => {
  const { emailState } = useEmailEditor()

  const currentHotelName = useSelector(selectCurrentHotelName)

  const { subject, preheaderText } = emailState

  return (
    <div className={styles.inboxPreview}>
      <div>
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="4" cy="4" r="4" fill="#2563EB" />
        </svg>
      </div>
      <div className={styles.inboxText}>
        <p className={styles.hotelName}>{currentHotelName}</p>
        <p className={styles.subject}>{(subject || '').substr(0, 62)}</p>
        <p className={styles.preheader}>{(preheaderText || '').substr(0, 62)}</p>
      </div>
      <p className={styles.time}>{moment().format('h:mm A')}</p>
    </div>
  )
}

const EmailPreview = ({
  isEditable = true,
  children,
  holderClassName,
  testHolderClassName,
  skipInitialSectionReset = false,
  hideEditContentButton = false
}) => {
  const { setEditingSection, previewHtml, handleClick, editingSection } = useEmailEditor()

  useEffect(() => {
    if (!skipInitialSectionReset) {
      setEditingSection('inbox-preview')
    }
  }, [setEditingSection, skipInitialSectionReset])

  const canClickPreviewSections =
    isEditable && (skipInitialSectionReset || editingSection !== 'inbox-preview')

  return (
    <>
      <div className={[styles.emailHolder, holderClassName].filter(Boolean).join(' ')}>
        {!hideEditContentButton && editingSection === 'inbox-preview' && isEditable && (
          <button className={styles.editButton} onClick={() => setEditingSection('body')}>
            <EditContentButtonIcon />
            Edit content
          </button>
        )}
        <div
          className={[styles.emailWrapper, 'no-style-reset'].join(' ')}
          dangerouslySetInnerHTML={{
            __html: previewHtml
          }}
          onClick={handleClick}
          style={{
            pointerEvents: canClickPreviewSections ? 'auto' : 'none'
          }}
        />

        {/* <iframe
        title="Email Preview"
        className={styles.emailPreviewIframe}
        srcDoc={previewHtml}
        height={800}
        width={540}
        allowTransparency={true}
        /> */}
      </div>
      {children && (
        <div className={[styles.testEmailHolder, testHolderClassName].filter(Boolean).join(' ')}>
          {children}
        </div>
      )}
    </>
  )
}

export default EmailPreview
